import React, { Dispatch, SetStateAction } from 'react';
import { Mascot } from './components/Mascot';
import { UserLogo } from './components/UserLogo';
import './styles/index.css';
import { ThemeType } from '@gravity-ui/uikit';
import { ThemeSwitcher } from './components/ThemeSwitcher';
import { UserSettingsCard } from './components/UserSettings';
import { HelpMenu } from './components/HelpMenu';
import { UserSettings } from '../../types/user/UserSettings';

type HeaderProps = {
    avatar: string;
    settings: UserSettings;
    setSettings: Dispatch<SetStateAction<UserSettings>>;
    toggleTheme?: () => void;
    theme: ThemeType;
};

export function Header({ avatar, settings, setSettings, toggleTheme, theme }: HeaderProps) {
    return (
        <header className="Header">
            <div className="Header-container">
                <div className="Header-logo-container">
                    <Mascot theme={theme} />
                </div>
                <div className="Header-logo-container">
                    <HelpMenu />
                    <UserSettingsCard settings={settings} setSettings={setSettings} />
                    {toggleTheme ? (
                        <ThemeSwitcher
                            onUpdate={toggleTheme}
                            theme={theme}
                            className="Header-theme_switcher"
                        />
                    ) : null}
                    <UserLogo avatar={avatar} />
                </div>
            </div>
        </header>
    );
}
